import { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { AdminPublicInfo } from '../../Api/Admin/models'
import { GetCbuResponse } from '../../Api/CBU/models'
import { fetchStaticButton } from '../../Api/Buttons/Buttons'
import { Button } from '../../Api/Buttons/models'
import { subtractCoins } from '../../Api/LoadPanel/LoadPanel';
import { useGetTimeForHistory } from './useGetTimeForHistory';
import toast from 'react-hot-toast';
import { useCheckBonifications } from './useCheckBonifications';

interface Props {
    adminInfo: AdminPublicInfo | null
    setForm: (form: any) => void
    setLoading: (loading: boolean) => void
    setDropdownOpen: (dropdownOpen: boolean) => void
    fetchedData: GetCbuResponse | null
    form: any
    loading: boolean
    setHistorial: (historial: any[]) => void
    historial: any[]
    setErrorQuantities: (errorQuantities: number) => void
    errorQuantities: number
    showHistory: boolean
    setShowHistory: (showHistory: boolean) => void
    setShowConfirmBonificationNotUsed: (showConfirmBonificationNotUsed: boolean) => void
    setBonificationsData: (bonificationsData: any) => void
}



export const useSubtractCoins = ({
    adminInfo,
    setForm,
    setLoading,
    setDropdownOpen,
    fetchedData,
    form,
    loading,
    setHistorial,
    historial,
    setErrorQuantities,
    errorQuantities,
    showHistory,
    setShowHistory,
    setShowConfirmBonificationNotUsed,
    setBonificationsData,
}: Props) => {

    const { getTime } = useGetTimeForHistory()
    const { checkNonUsedBonificationsGrenbet } = useCheckBonifications()

    const [messagesSubtractCoins, setMessagesSubtractCoins] = useState<Button>({
        id: '',
        name: '',
        category: '',
        createdAt: '',
        updatedAt: '',
        OwnerId: '',
        Messages: []
    })


    // MAIN FUNCTION
    const handleSubtractCoins = async ({ validated = false }: { validated?: boolean } = {}) => {
        if (loading) { return }
        if (form.quantity < 1 || form.name < 1) { Swal.fire({ text: 'Debes introducir nombre y cantidad de fichas.' }); return }
        if (isNaN(Number(form.quantity))) {
            Swal.fire({ text: 'Debes introducir un número válido.' });
            return;
        }
        setLoading(true)


        // Check bonifications GreenBet
        if (adminInfo?.platform === 'greenbet' && adminInfo?.checkBonifications) {
            const response = await checkNonUsedBonificationsGrenbet({ name: form.name, quantity: form.quantity })
            if (response?.success && !validated) {
                setBonificationsData(response)
                setShowConfirmBonificationNotUsed(true)
                setLoading(false)
                return;
            }
            if (!response?.success && response?.message === 'quantity-error') {
                Swal.fire({ icon: 'error', text: `El usuario ${form.name} no tiene suficientes fichas. Actualmente tiene ${response?.totalAmount} fichas.` });
                setLoading(false)
                return;
            }
        }

        setForm({
            name: '',
            quantity: '',
            senderName: '',
            destinationAccountName: fetchedData?.titular ?? ''
        })


        const copyMessage = async (text: string) => {
            let updatedMessage = text
                .replaceAll('__CANTIDAD__', form.quantity)
                .replaceAll('__USUARIO__', form.name)
                .replaceAll('__PASSWORD__', adminInfo?.default_users_password ?? 'hola123')
                .replaceAll('__LINK__', `${adminInfo?.pageLink}`)


            await navigator.clipboard.writeText(updatedMessage);
        }

        let randomIndex = Math.floor(Math.random() * messagesSubtractCoins?.Messages?.length);
        let randomValue = messagesSubtractCoins?.Messages[randomIndex];
        if (randomValue) copyMessage(randomValue.text)
        setDropdownOpen(false);


        try {
            const result = await subtractCoins({
                name: form.name,
                quantity: form.quantity,
            })


            if (result?.data?.success) {
                toast.success(`${form.quantity} fichas bajadas a ${form.name}`)
                let record = { user: form.name, quantity: form.quantity, hour: getTime(), success: true, type: 'bajar' }
                setHistorial([...historial, record])
            } else {
                let record = { user: form.name, quantity: form.quantity, hour: getTime(), success: false, info: result.data, type: 'bajar' }
                setHistorial([...historial, record])
                if (!showHistory) setErrorQuantities(errorQuantities + 1)
                const errorMessage = result?.response?.data?.message ?? 'Ha habido un error. Reinicia e intenta de nuevo.'
                Swal.fire({ icon: 'error', text: errorMessage });
            }

        } catch (error: any) {
            let errorMessage = error?.response?.data?.message ?? 'ERROR: No se ha podido bajar, verifica tu conexión y que el usuario tenga suficientes fichas disponibles.'
            let record = { user: form.name, quantity: form.quantity, hour: getTime(), success: false, info: errorMessage, type: 'bajar' }
            setHistorial([...historial, record])
            if (!showHistory) setErrorQuantities(errorQuantities + 1)
            Swal.fire({ icon: 'error', text: errorMessage });
        } finally {
            setLoading(false)
        }
    }


    useEffect(() => {
        fetchStaticButton('static_subtract').then((res) => {
            setMessagesSubtractCoins(res)
        })
    }, [])


    return {
        handleSubtractCoins,
        historial,
        errorQuantities,
        showHistory,
        setShowHistory,
        setErrorQuantities
    }





}
